<template>
  <div id="app">
    <div v-if="showLoading" class="loading">
      <div class="loading_box">
        <van-loading size="24px" vertical color="#fff" type="spinner">Loading...</van-loading>
      </div>

    </div>

    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      // showLoading:this.$store.state.loading
    }
  },
  created() {
    // console.log(this.$store.state.loading)
  },
  computed:{
    showLoading(){
      return this.$store.state.loading
    }

  },
}





</script>
<style src="./assets/css/normalize.css"></style>
<style>
#app {
  /*font-family: Arial, sans-serif;*/
  font-family: ProximaNova,sans-serif,Arial,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  /*color: #2c3e50;*/
  color: #454545;

  font-size: 14px;
  overflow-x: hidden;
  min-height: 100vh;
  position: relative;
}
  a{
    color: #454545!important;
  }
  .loading{
    position: fixed!important;
    z-index: 10!important;
    width: 100%!important;
    height: 100%!important;
    display: flex!important;
    align-items: center!important;
    justify-content: center!important;
    background: rgba(0,0,0,0.1)!important;

  }
.loading_box{
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 5px;
  background: hsl(0deg 0% 9% / 80%);
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/App.vue